import { isType, Action } from "typescript-fsa";
import update from "immutability-helper";
import log from "loglevel";

import { isFailedResponseUnauthenticatedNotLogin } from "@api/actions";
import { logout } from "@auth/actions";
import * as actions from "../actions";
import { SearchInternalState as State, SearchResponse } from "../models";

const getInitialState = () => ({
    query: null,
    request: null,
    response: null,
} as State);

function search(state: State = getInitialState(), action: actions.SearchAction): State {
    // State should never be null...
    if (state === null) {
        log.warn("search state setting to null, resetting to initialState.");
        state = {} as State;
        state = update(state, { $set: getInitialState() });
    }

    if (isType(action, actions.search)) {
        // search action
        return searchAction(state, action);
    }
    else if (isType(action, actions.requestSearch)) {
        // requestSearch
        return requestSearch(state);
    }
    else if (isType(action, actions.searchSuccess)) {
        // searchSuccess
        return searchSuccess(state, action);
    }
    else if (isType(action, logout) || isFailedResponseUnauthenticatedNotLogin(action)) {
        // Clear the state on logout.
        return update(state, { $set: getInitialState() });
    }
    // Otherwise we do nothing
    return state;
}

function searchAction(state: State, action: Action<string>): State {
    return update(state, {
        $merge: {
            query: action.payload,
        },
    });
}

function requestSearch(state: State): State {
    return update(state, {
        $merge: {
            request: {
                query: state.query,
                started: new Date(),
            },
        },
    });
}

function searchSuccess(state: State, action: Action<SearchResponse>): State {
    // Only update if it's the current query.
    const response = action.payload;
    // If the state query is empty, update that too.
    if (state.query == null) {
        state = update(state, { query: { $set: response.query } });
    }
    if (state.query === response.query) {
        return update(state, {
            $merge: {
                request: null,
                response: {
                    query: response.query,
                    albums: response.albumIds,
                    tracks: response.trackIds,
                    lastLoaded: new Date(),
                },
            },
        });
    }
    return state;
}

export {
    getInitialState,
    search,
};
